angular.module('bmsApp.marketing').factory('InitiativeSvc', function ($http, $log, $window, $q, CRUDSvc, INITIATIVE_API) {

	return {
		index: function (params) {
			return CRUDSvc.get(INITIATIVE_API.INDEX, params);
		},
		read: function (id) {
			return CRUDSvc.get(INITIATIVE_API.READ + id);
		},
		names: function (params) {
			return CRUDSvc.get(INITIATIVE_API.NAMES, params);
		},
		statuses: function (params) {
			return CRUDSvc.get(INITIATIVE_API.STATUSES, params);
		},
		create: function (data) {
			return CRUDSvc.create(INITIATIVE_API.CREATE, data);
		},
		update: function (data) {
			return CRUDSvc.update(INITIATIVE_API.UPDATE, data.id, data);
		},
		delete: function (initiative, id) {
			return CRUDSvc.update(INITIATIVE_API.DELETE, id, initiative);
		},
		options: function (params) {
			return CRUDSvc.get(INITIATIVE_API.OPTIONS, params);
		}
	}

}).constant('INITIATIVE_API', {
	INDEX: 'api/marketing/initiatives/index',
	READ: 'api/marketing/initiative/read/',
	NAMES: 'api/marketing/initiative/names',
	STATUSES: 'api/marketing/initiative/statuses',
	CREATE: 'api/marketing/initiative/create',
	UPDATE: 'api/marketing/initiative/update',
	DELETE: 'api/marketing/initiative/delete',
	OPTIONS: 'api/marketing/initiative/options'
});
